module.exports = __webpack_public_path__ + "media/images/normas-ba_icon_128-99408d2228f9385e1ccec9d46e19d1e2.png";